export const getNewData = (column) => {
  //获取titleblock数据转换
  let data = [];
  let data_ = column;
  for (let i = 0; i < data_.attCtr; i++) {
    var add_data = {};
    //console.log(index);
    add_data.index = i;
    add_data.id = data_.ids[i];
    add_data.defaultValue = data_.defaultValues[i];
    //add_data.editable = data_.editable[i];
    // if (data_.editable[i] == 1) { //是否可编辑
    // 	add_data.editable = true;
    // } else {
    // 	add_data.editable = false;
    // };

    add_data.editable = data_.editable[i] == 1; //是否可编辑
    add_data.listType = data_.listTypes[i];

    add_data.name = data_.names[i]; //key
    add_data.descriptions = data_.descriptions[i];
    if (data_.required[i] == 1) {
      //是否必填
      add_data.required = true;
    } else {
      add_data.required = false;
    }
    add_data.uiType = data_.uiTypes[i]; //val的类型
    if (data_.listIds[i] == "-1") {
      add_data.listId = "";
    } else {
      add_data.listId = data_.listIds[i]; //下拉菜单的类型号
    }
    let val = data_.listIds[i];
    let key = data_.listEntries;
    //console.log('999999',key);
    if (key && key[val + ""]) {
      var listEntrie_ = [];
      var old_data = key[val + ""];
      var key_ = Object.keys(old_data);
      var val_ = Object.values(old_data);
      // console.log(33333,val_);
      //console.log(key_);
      for (let j = 0; j < key_.length; j++) {
        if (key_[j] == -1) {
          val_[j] = val_[j].replace(/entryValue/g, "label");
          val_[j] = val_[j].replace(/pid/g, "value");
          let m = JSON.parse(val_[j])[0];
          // console.log(val_);
          // this.delChild(val_);
          del(m);
          listEntrie_ = listEntrie_.concat(m);
          // add_data.listType = 2
        } else if (add_data.listType == 3) {
          listEntrie_ = [];
        } else {
          listEntrie_.push({ id: key_[j], name: val_[j] });
        }
      }
      //console.log(listEntrie_);
      add_data.listEntrie = listEntrie_;
    } else {
      add_data.listEntrie = "";
    }
    //console.log(add_data);
    data.push(add_data);
  }
  // console.log(data);
  return data;
};

const del = function (arr) {
  for (let item of arr) {
    delete item.description;
    delete item.enabled;
    delete item.listId;
    delete item.parent;
    delete item.parentEntry;
    if (item.children.length == 0) {
      delete item.children;
    } else if (item.children.length > 0) {
      del(item.children);
    }
  }
  return arr;
};

export const getReq = (columns) => {
  const arr = columns
    .map((i) => {
      const { ids, names, required } = i.column.object.columnInfo;
      return { ids, names, required };
    })
    .reduce((prev, cur) => {
      const obj = {};
      for (const key in prev) {
        if (Object.prototype.hasOwnProperty.call(prev, key)) {
          obj[key] = { ...prev[key], ...cur[key] };
        }
      }
      return obj;
    });
  console.log(arr);

  return arr;
};

export const getMultiList = (obj) => {
  let arr = [];
  obj.uiTypes.map((i, e) => {
    if (i == 4) {
      return arr.push(obj.ids[e]);
    }
  });
  return arr;
};



/**
 * Check required form Subform
 * @param {object} obj
 * @returns
 */

export function checkSubformRequied({ columns, vals }) {

  const arr = columns.map(item => {
    const { required, ids, names } = item;
    const tempArr = required.map((i, e) => {
      const id = ids[e], name = names[e], required = i;
      return { id, name, required }
    })
    return tempArr
  }).reduce((prev, next) => {
    return [...prev, ...next]
  })
  const valList = vals.reduce((prev, next) => {
    return { ...prev, ...next }
  })

  const str = arr.filter((i, e) => i.required && !valList[i.id]).map((i) => i.name).join(';')
  return str

}



/**
 * Check required form Subform
 * @param {Number} baseId
 * @returns
 */
export function getSaveUrl(baseId) {
  const urlMap = new Map([
    [101, "/pmdm/items/saveItemP1P2P3"],
    [104, "/pmdm/changes/saveChangeP1P2P3"],
    [105, "/pmdm/manufacturers/saveManufacturerP1P2P3"],
    [106, "/pmdm/manufacturerPart/saveManufacturerPartP1P2P3"],
    [301, "/ppm/project/saveProject"],
    [401, "/pqm/quality/saveQualityP1P2P3"],
    [501, "/pmdm/technology/saveTechnologyP1P2P3"],
    [502, "/pmdm/resource/saveResourceP1P2P3"],
  ]);
  const url = urlMap.get(baseId);
  return url
}